'use strict';

import 'angular';

import incidentsServiceModule from './incidents';

const MODULE_NAME = 'daupler.incidents.services';

angular.module(MODULE_NAME, [
	incidentsServiceModule,
]);

export default MODULE_NAME;
